import { Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { CustomRoleDto } from '../../../../../api-client';
import React from 'react';
import {
  PermissionBox,
  TypographyWithEllipsis,
} from '../../../../BuiltInRoles/ui/RolesListRow/RolesListRow.styles';
import { useFeatureFlags } from '@hiiretail/core';

type CustomRolePermissionsRowProps = {
  customRole: CustomRoleDto;
};

export type CustomRolePermissionsRowComponent = React.FC<CustomRolePermissionsRowProps>;

export const CustomRolePermissionsRow: CustomRolePermissionsRowComponent = ({ customRole }) => {
  const { useFlags } = useFeatureFlags();
  const flags = useFlags();
  const isFixedBindingsEnabled = flags?.releaseIamCustomRoleFixedBindings ?? false;

  return (
    <Flexbox
      container
      alignItems="center"
      gutter={2}
      style={{ width: '100%', overflowY: 'auto', paddingBottom: '16px' }}
    >
      <>
        {isFixedBindingsEnabled && customRole.fixedBindings?.length ? (
          <Tooltip
            title={
              <Typography color={() => 'white'}>
                Fixed bindings: <br />
                <br />
                {customRole.fixedBindings.map((fixedBinding) => (
                  <div key={fixedBinding}>{fixedBinding}</div>
                ))}
              </Typography>
            }
          >
            <div data-testid="tooltip">
              <Icon.Info size="md" />
            </div>
          </Tooltip>
        ) : null}
        {customRole.permissions.length ? (
          <>
            {customRole.permissions.map((customRolePermission) => (
              <PermissionBox item key={customRolePermission.id}>
                {/*  @ts-ignore  */}
                <TypographyWithEllipsis variant="caption" weight="bold">
                  {customRolePermission.id}
                </TypographyWithEllipsis>
              </PermissionBox>
            ))}
          </>
        ) : (
          <Typography variant="body2">No permissions</Typography>
        )}
      </>
    </Flexbox>
  );
};
